// extracted by mini-css-extract-plugin
export default {"heading":"styles_heading__hmTb2","list":"styles_list__N9nt6"};